export function fmtWan(val, digits = 0) {
  if (val == null || val === '' || Number.isNaN(Number(val))) return '—'
  const n = Number(val)
  return n.toLocaleString('zh-CN', { maximumFractionDigits: digits, minimumFractionDigits: digits })
}

export function fmtPct(val, digits = 1) {
  if (val == null || val === '' || Number.isNaN(Number(val))) return '—'
  return `${Number(val).toFixed(digits)}%`
}

export function fmtDiff(val, suffix = '') {
  if (val == null || val === '' || Number.isNaN(Number(val))) return '—'
  const n = Number(val)
  const sign = n > 0 ? '+' : ''
  return `${sign}${fmtWan(n)}${suffix}`
}

export function varianceClass(val, invert = false) {
  if (val == null || Number.isNaN(Number(val))) return ''
  const n = Number(val)
  const positive = invert ? n < 0 : n > 0
  const negative = invert ? n > 0 : n < 0
  if (positive) return 'var-pos'
  if (negative) return 'var-neg'
  return ''
}
